import React, { ReactElement, SVGProps } from 'react'
import BaseIcon from "./BaseIcon";

export default function PencilIcon(props: SVGProps<any>): ReactElement {
  return (
    <BaseIcon {...props}>
      <path
        d="M21.178 7.011 16.989 2.82a1.311 1.311 0 0 0-1.857 0L3.571 14.382a1.306 1.306 0 0 0-.384.928v4.19A1.313 1.313 0 0 0 4.5 20.813h4.19a1.309 1.309 0 0 0 .928-.384l11.56-11.562a1.314 1.314 0 0 0 0-1.856ZM8.82 19.632a.188.188 0 0 1-.132.055H4.5a.188.188 0 0 1-.187-.187v-4.19a.18.18 0 0 1 .055-.132l8.382-8.383 4.455 4.455-8.384 8.382Zm11.56-11.56L18 10.455 13.545 6l2.383-2.383a.186.186 0 0 1 .265 0l4.188 4.19a.189.189 0 0 1 .041.206.189.189 0 0 1-.041.06Z"
        fill="currentColor" />
    </BaseIcon>
  )
}
